// src/pages/Home.jsx
import React from 'react';
import { Box } from '@mui/material';
import Hero from "../components/Hero.jsx";
import LatestCollection from "../components/LatestCollection.jsx";
import BestSeller from "../components/BestSeller.jsx";
import OurPolicy from "../components/OurPolicy.jsx";
import NewsletterBox from "../components/NewsletterBox.jsx";

const Home = () => {
  return (
    <Box component="main">
      <Hero />
      <LatestCollection />
      <BestSeller />
      <OurPolicy />
      <NewsletterBox />
    </Box>
  );
};

export default Home;

